<template>
    <div style="width: 100%;height: 100%;border: 1px solid rgba(63,61,61,0.70)">
        <textarea ref="coder"></textarea>
    </div>
</template>

<script>
    import 'codemirror/theme/idea.css';
    import 'codemirror/theme/ambiance.css';
    import 'codemirror/theme/base16-light.css';
    import 'codemirror/theme/eclipse.css';
    import 'codemirror/lib/codemirror.css';
    import 'codemirror/addon/hint/show-hint.css';
    const CodeMirror = require('codemirror/lib/codemirror');
    require('codemirror/addon/hint/show-hint');
    export default {
        name: "CustomCoder",
        props: {
            code: {
                type: String,
                required: true
            },
            customAutoComplete: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            width: {
                type: String,
                default: '100%'
            },
            height: {
                type: String,
                default: '100%'
            }
        },
        data: function () {
            return {
                codeText: '',
                coder: undefined,
                coderOption: {
                    // 选择对应代码编辑器的语言
                    // mode: null,
                    // 初始值
                    theme: 'idea',
                    // indentWithTabs: true,
                    smartIndent: true,
                    // 是否显示行号
                    lineNumbers: true,
                    value: '',
                    matchBrackets: true,
                    extraKeys: { 'Alt': 'autocomplete' }, // 自定义快捷键
                    hintOptions: {
                        // 自定义提示选项
                        tables: this.customAutoComplete,
                        // 单个提示项是否自动选择
                        completeSingle: false,
                        hint: this.hintFun,
                        // 是否在光标离开时关闭提示
                        closeOnUnfocus: true
                    }
                }
            }
        },
        methods: {
            initialization: function () {
                this.coder = CodeMirror.fromTextArea(this.$refs.coder, this.coderOption);

                // 编辑器内容改变时触发
                this.coder.on('change', (ele, data) => {
                    this.codeText = ele.getValue();
                })

                // 输入或粘贴时触发
                this.coder.on('inputRead', (instance, changeObj) => {
                    // 过滤掉空格回车等输入
                    if (!/\s/.test(changeObj.text[0])) {
                        this.coder.showHint()
                    }
                });

                this.setValue(this.code);
            },
            updateCode: function (text) {
                this.$emit('update:code', text)
            },
            setValue: function (val) {
                this.coder.setValue(val);
            },
            // 自定义提示获取方法
            hintFun: function (coder, arg2) {
                // 获取光标对象
                let cursor = coder.getCursor();
                // 获取当前行内容
                let line = coder.getLine(cursor.line).toUpperCase();
                // 获取当前光标位置
                let start = cursor.ch
                let end = cursor.ch
                // 找到单词起始位置（即第一个空白字符或左右括号或点）
                while (start && !/\s|\(|\)|,/.test(line.charAt(start - 1))) {
                    start --;
                }
                // 找到单词截止位置
                while (end && /\s|\(|\)/.test(line.charAt(end - 1))) {
                    end --;
                }
                line = line.substr(start, end - start);
                console.log(line);
                let allOption = this.customAutoComplete;
                // let keys = Object.keys(allOption);
                let additionOption = this.recursionMatched(allOption, '', line);
                arg2.tables = {};
                let sql = CodeMirror.hint.sql(coder, arg2);
                sql.from.ch = start;
                arg2.tables = allOption;
                sql.list = additionOption;
                return sql;
            },
            recursionMatched: function (array, parentText, target) {
                let addition = [];
                for (let i = 0; i < array.length; i++) {
                    let item = array[i];
                    let matchedText = this.$comUtils.isEmpty(item.show) ? item.value : item.show
                    // 匹配一级节点
                    if (matchedText.toUpperCase().startsWith(target)) {
                        addition.push({
                            displayText: (!this.$comUtils.isEmpty(parentText) ? (parentText + '.') : '') + matchedText,
                            text: item.value,
                        })
                    }
                    if (!this.$comUtils.isEmpty(item.children)) {
                        let matched = this.recursionMatched(item.children,  parentText + '.' + matchedText, target);
                        addition.push(...matched);
                    }
                }
                return addition;
            }
        },
        watch: {
            codeText: function (nv, ov) {
                this.updateCode(nv);
            },
            code: function (nv, ov) {
                if (this.codeText !== nv) {
                    this.setValue(nv);
                }
                this.codeText = nv;
            },
            customAutoComplete: {
                handler: function (nv, ov) {
                    let opt = {
                        // 自定义提示选项
                        tables: nv,
                        // 单个提示项是否自动选择
                        completeSingle: false,
                        // 是否在光标离开时关闭提示
                        closeOnUnfocus: true,
                        hint: this.hintFun,
                    }
                    this.coder.setOption('hintOptions', opt);
                },
                deep: true
            }
        },
        mounted() {
            this.initialization();
        }
    }
</script>

<style scoped>

</style>
<style>
    .CodeMirror {
        height: 100%;
        /*width: 100%;*/
        font-family: unset;
        z-index: 1000;
    }
    .CodeMirror-hints {
        z-index: 9999;
    }
    .CodeMirror-code{
        line-height: normal;
    }
</style>
